import { UploadOutlined } from '@ant-design/icons';
import { Button, Form, Image, Input, InputNumber, Select, Upload } from 'antd';
import apiBanksCall from 'apps/catalog/apiCalls/bank/list';
import { useFetchApiList } from 'hooks/api';
import {
  productRiskLevelOptions,
  productStatusOptions,
} from 'apps/investment/constants/fundProduct';
import UIDatePicker from 'common/ui/UIDatePicker';
import { useEffect } from 'react';
import { formItemLayout, tailFormItemLayout } from 'utils/formConfig';
import { convertDateFormData, ensureDateFields } from 'utils/formData';
import { createVietnameseFilter } from 'utils/vietnamese-search';

const dateFields = ['inception_date'];

const ItemForm = ({ form, submiting, onFinish, initialValues, name }) => {
  const { logo } = initialValues || {};

  const normFile = e => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const { data: banks = [], load: loadBanks } = useFetchApiList(apiBanksCall, { resourceName: 'data' });

  useEffect(() => {
    loadBanks({ page_size: 99 });
  }, []);

  useEffect(() => {
    form.setFieldsValue(ensureDateFields(initialValues, dateFields));
  }, [form, initialValues]);

  return (
    <Form
      {...formItemLayout}
      form={form}
      name={name || 'product_form'}
      onFinish={values =>
        onFinish(convertDateFormData(values, dateFields), ['logo'])
      }
      initialValues={ensureDateFields(initialValues, dateFields)}
      scrollToFirstError
    >
      <Form.Item name="alias" label="Alias">
        <Input placeholder="" />
      </Form.Item>
      <Form.Item
        name="logo"
        label="Logo"
        valuePropName="fileList"
        getValueFromEvent={normFile}
      >
        <Upload.Dragger
          listType="picture"
          beforeUpload={() => false}
          accept="image/*"
          maxCount={1}
          showUploadList={true}
          onChange={info => {
            // Manually update the form field value
            form.setFieldValue('logo', info.fileList);
          }}
        >
          <Button icon={<UploadOutlined />}>Click to Upload Logo</Button>
        </Upload.Dragger>
        {logo && <Image width={100} src={logo} />}
      </Form.Item>

      <Form.Item name="name" label="Name">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="description" label="Description">
        <Input.TextArea rows={10} />
      </Form.Item>

      <Form.Item name="order_closing_time" label="Order closing time">
        <Input placeholder="" />
      </Form.Item>
      <Form.Item name="order_time" label="Order time">
        <Input placeholder="" />
      </Form.Item>
      <Form.Item name="fund_manager_name" label="Fund Manager Name">
        <Input placeholder="" />
      </Form.Item>
      <Form.Item name="inception_date" label="Inception Date">
        <UIDatePicker />
      </Form.Item>
      <Form.Item name="policy_url" label="Policy Url">
        <Input placeholder="" />
      </Form.Item>
      <Form.Item name="prospectus_url" label="Prospectus Url">
        <Input placeholder="" />
      </Form.Item>
      <Form.Item
        name="registration_certificate"
        label="Registration Certificate of Establishment"
      >
        <Input placeholder="" />
      </Form.Item>
      <Form.Item name="strategy" label="Strategy">
        <Input.TextArea rows={10} />
      </Form.Item>

      <Form.Item name="buy_minimum_amount" label="Buy Minimum Amount">
        <InputNumber
          style={{ width: '100%' }}
          formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        />
      </Form.Item>

      <Form.Item name="risk_level" label="Risk Level">
        <Select>
          {productRiskLevelOptions &&
            productRiskLevelOptions.map(option => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>

      <Form.Item name="custodian_bank_id" label="Custodian Bank">
        <Select
          showSearch
          optionFilterProp="name"
          options={banks}
          fieldNames={{ label: 'name', value: 'id' }}
          placeholder="Select Custodian Bank"
          filterOption={createVietnameseFilter(['name', 'code'])}
        />
      </Form.Item>

      <Form.Item name="supervisory_bank_id" label="Supervisory Bank">
        <Select
          showSearch
          optionFilterProp="name"
          options={banks}
          fieldNames={{ label: 'name', value: 'id' }}
          placeholder="Select Supervisory Bank"
          filterOption={createVietnameseFilter(['name', 'code'])}
        />
      </Form.Item>

      <Form.Item name="audit_company" label="Audit Company">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="management_fee" label="Management Fee">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="status" label="Status">
        <Select>
          {productStatusOptions &&
            productStatusOptions.map(option => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>

      <Form.Item {...tailFormItemLayout}>
        <Button type="primary" htmlType="submit" loading={submiting}>
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ItemForm;
